export enum CoachRatingScreen {
  LOADING,
  ERROR,
  ALREADY_RATED,
  RATE_NOW,
  EXPIRED
}
